import { render, staticRenderFns } from "./TagLabel.vue?vue&type=template&id=ef3052f4&scoped=true&"
import script from "./TagLabel.vue?vue&type=script&lang=js&"
export * from "./TagLabel.vue?vue&type=script&lang=js&"
import style0 from "./TagLabel.vue?vue&type=style&index=0&id=ef3052f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3052f4",
  null
  
)

export default component.exports